const useLocalStorage = () => {
  const getLocalStorage = (key) => JSON.parse(localStorage.getItem(key));
  const setLocalStorage = (key, value) =>
    localStorage.setItem(key, JSON.stringify(value));
  const removeItemFromStorage = (key) => localStorage.removeItem(key);
  const clearStorage = () => localStorage.clear();
  return {
    setLocalStorage,
    clearStorage,
    getLocalStorage,
    removeItemFromStorage,
  };
};

export default useLocalStorage;
